import * as h2Api from '../h2Api'
import * as profileActions from '../actions/pathwayProfile'
import * as earlyListingActions from '../actions/early/earlyListing'

const initialState = {
  selectedProfile: null,
  profileCache: {}
}
const pathwayProfile = (state = initialState, action) => {
  switch (action.type) {
    case profileActions.PROFILE_SELECT_LOADED:
      return {
        ...state,
        selectedProfile: action.selectedPathway
      }

    case profileActions.UPDATE_PROFILE_CACHE:
      return {
        ...state,
        profileCache: {
          ...state.profileCache,
          [action.pathway.id]: action.pathway
        }
      }

    case earlyListingActions.LOAD_GAME:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          profileCache: (action.restCall.result.pathwayProfiles || []).reduce(function (
            map,
            obj
          ) {
            map[obj.id] = obj

            return map
          },
          {})
        }
      }

    case profileActions.PROFILE_LOAD:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          selectedProfile: action.restCall.result.id,
          profileCache: {
            ...state.profileCache,
            [action.restCall.result.id]: action.restCall.result
          }
        }
      }

      return state

    default:
      return state
  }
}

export default pathwayProfile
